export default __webpack_public_path__ + "static/media/appstore_fr_badge_web.a84d3d06.png";